import { useCallback, useState } from 'react';

export type UseBuyerLogoDropzoneReturn = {
  isDragging: boolean;
  handleDragOver: (e: React.DragEvent) => void;
  handleDragLeave: (e: React.DragEvent) => void;
  handleDrop: (e: React.DragEvent) => void;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

/**
 * Drag-and-drop + file-input plumbing for the dropzone. Kept separate so the
 * drag-hover highlight only re-renders the step using it, not the whole modal.
 */
export const useBuyerLogoDropzone = (
  onFile: (file: File | null) => void | Promise<void>,
): UseBuyerLogoDropzoneReturn => {
  const [isDragging, setIsDragging] = useState(false);

  const handleDragOver = useCallback((e: React.DragEvent) => {
    e.preventDefault();
    setIsDragging(true);
  }, []);

  const handleDragLeave = useCallback((e: React.DragEvent) => {
    e.preventDefault();
    setIsDragging(false);
  }, []);

  const handleDrop = useCallback(
    (e: React.DragEvent) => {
      e.preventDefault();
      setIsDragging(false);
      void onFile(e.dataTransfer.files[0] ?? null);
    },
    [onFile],
  );

  const handleInputChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      void onFile(e.target.files?.[0] ?? null);
      e.target.value = '';
    },
    [onFile],
  );

  return {
    isDragging,
    handleDragOver,
    handleDragLeave,
    handleDrop,
    handleInputChange,
  };
};
